import { asap, safeCallback } from "../helpers/fn.js";
import { observer, observerToTriggers, proxyToSubject, rawToObservers, rawToProxy, unobserve } from "./index.js";
//#region ../r-html/dist/observable/scheduler.js
var queue = [];
var queueMap = /* @__PURE__ */ new Map();
var watchQueue = /* @__PURE__ */ new Map();
var executable = true;
function isTrigger(raw, p, observer) {
	const triggers = observerToTriggers.get(observer);
	if (!triggers) return false;
	const trigger = triggers.get(raw);
	if (!trigger) return false;
	return trigger.has(p);
}
var createNextTick = (type) => (fn) => {
	const prevTask = queueMap.get(fn);
	let next = () => {};
	const promise = prevTask?.promise ? prevTask.promise : new Promise((resolve) => {
		next = resolve;
	});
	if (!prevTask) {
		const task = {
			type,
			promise,
			fn,
			resolve: () => {
				next();
			}
		};
		queue.push(task);
		queueMap.set(fn, task);
	}
	if (executable) {
		asap(executeAsap);
		executable = false;
	}
	return promise;
};
var observerNextTick = createNextTick("observer");
var nextTick = createNextTick("nextTick");
function cancelTask(fn) {
	const task = queueMap.get(fn);
	if (!task) return;
	const index = queue.indexOf(task);
	index === -1 || queue.splice(index, 1);
	queueMap.delete(fn);
	task.resolve();
}
var effect = (raw, p) => rawToObservers.get(raw)?.forEach((observer) => isTrigger(raw, p, observer) && observerNextTick(observer));
function runTask() {
	const task = queue.shift();
	if (!task) return;
	queueMap.delete(task.fn);
	if (task.type === "observer") {
		unobserve(task.fn);
		observer(task.fn);
		task.resolve();
	} else if (task.type === "nextTick") {
		const result = safeCallback(task.fn);
		result instanceof Promise ? result.finally(task.resolve) : task.resolve();
	}
}
function executeAsap() {
	while (queue.length) runTask();
	executable = true;
}
function watchEffect(raw, p) {
	const proxy = rawToProxy.get(raw);
	if (!proxy) return;
	const subject = proxyToSubject.get(proxy);
	if (!subject) return;
	const trigger = watchQueue.get(proxy);
	if (!trigger) {
		watchQueue.set(proxy, /* @__PURE__ */ new Set([p]));
		nextTick(() => {
			const trigger = watchQueue.get(proxy);
			if (!trigger) return;
			watchQueue.delete(proxy);
			trigger.forEach((propName) => subject.next(propName));
		});
	} else if (!trigger.has(p)) trigger.add(p);
}
//#endregion
export { cancelTask, effect, nextTick, watchEffect };
